import React from "react";

export function renderTitleWithValue(title, value, subtitle, optional) {
  return (
    <>
      <div className="fs-14 mb-2 tw:font-bold">
        <span>{title}</span>

        {optional && <span className="ml-1 tw:font-normal">(Optional)</span>}

        {subtitle && (
          <div className="fs-14 text-muted tw:font-normal">
            <span>{subtitle}</span>
          </div>
        )}
      </div>

      <div className="fs-14">
        <span>{formatDisplayValue(title, value)}</span>
      </div>
    </>
  );
}

const formatDisplayValue = (title, value) => {
  if (title !== "Mobile") return value;
  if (!value) return value;

  return formatMobileNumber(value);
};

const formatMobileNumber = (val) => {
  const first = val.substring(0, 3);
  const middle = val.substring(3, 6);
  const last = val.substring(6, 10);

  return `(${first}) ${middle}-${last}`;
};
